import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';

import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import CalenderEventForm from '../components/CalenderEventForm';
import calendarServices from '../calendarServices';



const CellActions = (props) =>{
	return(
		<>
			{/*<Link to={`/calendar/details/${props.data.id}`}>{props.data.title}</Link> */}
			  <CalenderEventForm  callBack={props.callBack} data={props.data} />
			{/*
			  <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
			*/}
		</>
	)
  }


function CalendarEventListPage() {

  const {getMasterLabel} = useAppData();
  const [calendarList,setCalendarList] = useState();

  const getCalendarList = () =>{
	calendarServices.getList().then(res=>{
		setCalendarList(res.data);
	}).catch(error=>{
		console.log(error);
	})
  }
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
	floatingFilter: true,
	filterParams: {
	  buttons: ['apply'],
	},
	resizable: true,
	width:120,
	filter:true,
	sortable: true,
	cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
	const prepairColumnDef = () => {
	let _columnDefs = [
		{field:"id",headerName: "ID"},
		
		{headerName:"Title", width:"200", valueGetter: params => params.data.title,
			cellRenderer: CellActions,
			cellRendererParams: {
				callBack:getCalendarList,
				remove:remove
			},
		}, 
		{field:"startDate",headerName: "Start Date"},
		{field:"startTime",headerName: "Start Time"},
		{field:"endDate",headerName: "End Date"},
		{field:"endTime",headerName: "End Time"},
		
		{field:"to",headerName: "Email"},
			 
	];
	setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
	gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
	prepairColumnDef();
  },[]);
  return (
	<ErpLayout>
	  <div className='row'>
		<div className='col-md-6'><h4>Calendars</h4></div>
		<div className='col-md-6'> 
		  <span className='float-end'><CalenderEventForm callBack={getCalendarList} /></span>
		  <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
		</div>
		<div className='col-md-12 mt-2'>
		  <div className="ag-theme-alpine" style={{height: 400}}>
			  <AgGridReact
				ref={gridRef}
				rowData={calendarList}
				columnDefs={columnDefs}
				defaultColDef={defaultColDef}
				animateRows={true}
				onGridReady={getCalendarList}
			  />
			</div>
		  </div>
		</div>
	</ErpLayout>
	
  )
}

export default CalendarEventListPage